import { usePlanMainTarget as useMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target/hooks";

import { useProductPlanI18nFormModelContext } from "../../../../context";

export const usePlanMainTarget = () => {
	const { viewModel, onSetViewModel } = useProductPlanI18nFormModelContext();

	const { mainTarget } = viewModel;

	return useMainTarget({ mainTarget, onSetViewModel });
};
